export const DECOR_MAX_FINISHED_WIDTH_MM = 1300;

export function assertDecorFinishedWidth(size, productLabel = "Veggdekor") {
  const widthMm = Number(size?.widthMm || 0);
  if (!Number.isFinite(widthMm) || widthMm <= 0) throw new Error(`${productLabel} mangler gyldig produksjonsbredde.`);
  if (widthMm > DECOR_MAX_FINISHED_WIDTH_MM) throw new Error(`${productLabel} kan maksimalt produseres i 130 cm bredde.`);
  return size;
}
